import './ActionChoiceModal.css';

import { useState } from 'react';

import type { Action, Content } from '../../../global-types/Content';
import useTracking from '../../../hooks/useTracking';
import { renderContent } from '../../../utils/renderContent';

type ActionChoiceModalProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action) => void;
  modalOpen: boolean;
};

function ActionChoiceModal({ content, viewId, dispatchActionEvent, modalOpen }: ActionChoiceModalProps) {
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const trackVisibilityElement = useTracking(content, modalOpen ? viewId : undefined);
  const [disableButton, setDisableButton] = useState(false);

  if (!view) return null;

  const { texts, buttonStyledActions } = renderContent({
    view,
    trackVisibilityElement,
    actionsConfig: {
      dispatchActionEvent,
      skipFirstAction: true,
      disableButton,
      setDisableButton,
    },
  });

  return (
    <div
      className="action-choice if modal-v19-content gap-16 small-padding flex-column background-beige-200"
      id="modal-v19-content"
    >
      {texts}
      <div className="if flex flex-column gap-24 ">{buttonStyledActions}</div>
    </div>
  );
}

export default ActionChoiceModal;
